var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeforeButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 76,
    viewBox: "0 0 45 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2073)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4319 0.160156L41.4078 12.971L44.6137 51.8141L43.9725 63.9838L42.9082 71.242L35.8679 75.0891L0 43.2735C0 43.2735 20.2743 14.8818 20.6975 14.0354C21.1207 13.1762 35.4191 0.160156 35.4191 0.160156H35.4319Z",
    fill: "url(#paint0_linear_1_2073)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.563936 43.2477L8.32228 41.1318L9.77136 44.5814L3.6288 46.4921L0.12793 43.3888L0.563936 43.2477Z",
    fill: "url(#paint1_linear_1_2073)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M20.3639 22.4348C20.3639 22.4348 14.8882 25.038 12.4004 25.8844C16.7092 19.8188 20.5306 14.4072 20.7102 14.0481C21.1333 13.1889 35.4318 0.172852 35.4318 0.172852L33.0338 7.86708L20.3511 22.4348H20.3639Z",
    fill: "url(#paint2_linear_1_2073)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7494 18.5367L20.3639 22.4351C20.3639 22.4351 14.8882 25.0384 12.4004 25.8847C16.7092 19.8191 20.5306 14.4075 20.7102 14.0484C20.8769 13.715 23.198 11.4837 25.9551 8.91895C25.2626 12.0736 24.1982 16.6516 23.7622 18.5624L23.7494 18.5367Z",
    fill: "url(#paint3_linear_1_2073)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.31
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2241 57.4313L35.7398 66.9465L37.4838 60.4833C37.4838 60.4833 36.9581 56.4951 36.9581 56.1232C36.9581 55.7513 34.9704 24.3589 34.9704 24.3589L40.8693 13.4844L41.472 13.6254L44.6138 51.8016L43.9726 63.9713L42.9083 71.2296L35.8681 75.0767L9.64355 51.8273L24.2241 57.4441V57.4313Z",
    fill: "#0043C9"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M37.484 60.4828C37.484 60.4828 36.9582 56.4946 36.9582 56.1227C36.9582 56.0073 36.7915 53.2117 36.5479 49.3133C37.407 47.5308 41.0618 37.4514 42.9982 32.0654L44.6268 51.814L43.9856 63.9837L37.4968 60.4828H37.484Z",
    fill: "url(#paint4_linear_1_2073)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.42
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6114 66.3819C36.8935 66.2921 40.7406 69.2672 42.9335 70.9984L42.895 71.2421L35.8548 75.0892L35.7266 66.9589L36.6114 66.3947V66.3819Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.42
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0466 9.31653C33.0466 9.31653 35.5215 24.2562 35.7395 24.6922C35.9576 25.1282 36.5987 61.9964 36.5987 61.9964L35.7395 66.9463L9.82282 45.2229C9.82282 45.2229 7.56584 41.5682 7.66843 41.1322C7.77102 40.6962 20.3511 22.4224 20.3511 22.4224L33.0337 9.30371L33.0466 9.31653Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4187 1.17285L33.8927 9.32874L35.688 23.1142C35.688 23.1142 40.856 13.24 40.856 13.5093C40.856 13.7786 35.7265 24.7044 35.7265 24.7044L36.2651 44.9658C36.2651 44.9658 34.9571 25.7046 34.9571 24.3838C34.9571 23.0629 32.636 10.1366 32.636 10.1366C32.636 10.1366 19.8507 23.3964 19.6455 23.5246C19.4532 23.6528 12.4258 25.7174 12.4258 25.7174L19.7866 22.4089L33.0463 7.89248C33.0463 7.89248 35.4315 0.99332 35.4315 1.1985L35.4187 1.17285Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9398 30.3213L7.25843 40.529L0.564453 43.2476L7.06608 41.9268L8.65622 44.7095L4.01403 46.2996L9.836 45.9021L24.2242 57.4306L9.77188 44.5813L8.3228 41.1317L14.9398 30.3213Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3809 49.5833L36.5989 61.9966C36.5989 61.9966 35.791 66.9081 35.7397 66.9466C35.6885 66.9851 35.8295 74.333 35.8295 74.333L36.6246 66.3823L42.4594 70.8193L36.958 65.4462L37.4838 60.4706L44.2419 51.8531L37.3555 59.4703L36.3809 49.5576V49.5833Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4963 56.7385C31.8669 48.121 19.6459 24.769 19.1458 25.0126C19.0304 25.0639 18.7354 25.1922 18.3379 25.3589C19.5433 23.602 20.3512 22.4222 20.3512 22.4222L22.2748 20.4346L22.839 20.691C23.4674 21.3194 32.8287 34.8356 36.1629 39.6573C36.2911 45.7101 36.4193 52.2887 36.4963 56.7257V56.7385Z",
    fill: "url(#paint5_linear_1_2073)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1713 53.0578C17.0939 48.9927 13.5032 41.555 10.9385 36.1947C11.9003 34.7712 12.9903 33.1683 14.0803 31.5781C14.1188 31.6551 14.1701 31.732 14.2085 31.7961C14.683 32.6297 27.0194 54.3017 32.3284 64.0862L19.1713 53.0578Z",
    fill: "url(#paint6_linear_1_2073)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1767 42.6709L36.3809 49.5829L31.3027 53.0966L35.9962 47.5311L40.1767 42.6709Z",
    fill: "url(#paint7_linear_1_2073)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M40.1767 42.6709L36.3809 49.5829L31.3027 53.0966L35.9962 47.5311L40.1767 42.6709Z",
    fill: "#031847"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5227 43.9922L36.3809 49.5833L31.3027 53.097L36.522 50.7118L39.5227 43.9922Z",
    fill: "url(#paint8_linear_1_2073)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2073",
    x1: 21.5438,
    y1: 71.8191,
    x2: 24.5061,
    y2: -23.1662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2073",
    x1: 1.10253,
    y1: 27.3079,
    x2: 6.01402,
    y2: 48.6209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2073",
    x1: 26.686,
    y1: 20.7036,
    x2: 21.1205,
    y2: 5.34081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2073",
    x1: 21.0051,
    y1: 5.14877,
    x2: 16.1193,
    y2: 37.5799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2073",
    x1: 44.6653,
    y1: 27.295,
    x2: 36.5094,
    y2: 81.4624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2073",
    x1: 39.6894,
    y1: 66.8692,
    x2: 12.7211,
    y2: -7.58525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2073",
    x1: 29.084,
    y1: 70.7033,
    x2: 2.11576,
    y2: -3.75121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2073",
    x1: 37.6248,
    y1: 52.8914,
    x2: 33.1109,
    y2: 40.9012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_2073",
    x1: 39.5099,
    y1: 48.5446,
    x2: 31.3027,
    y2: 48.5446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.6137,
    height: 74.9161,
    fill: "white",
    transform: "translate(0 0.160156)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeforeButton);
export default __webpack_public_path__ + "static/media/before-button.svg";
export { ForwardRef as ReactComponent };